/* The Wise Leopard: shared behaviour. Lenis smooth scroll, reveals, parallax, header, menu, video modal, sticky buy bar. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;
  /* homepage: the cookie banner waits for the first scroll */
  if (document.querySelector('.hero')) {
    body.classList.add('pc-wait');
    var pcShow = function () { if (window.scrollY > 40) { body.classList.remove('pc-wait'); window.removeEventListener('scroll', pcShow); } };
    window.addEventListener('scroll', pcShow, { passive: true });
  }

  /* page in */
  body.classList.add('ready');

  /* smooth scroll */
  var lenis = null;
  if (!reduce && window.Lenis && window.matchMedia('(pointer: fine)').matches) {
    lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  }
  window.TWL = { lenis: lenis };

  /* anchor links */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || a.hasAttribute('data-play-in')) return;
    var url = new URL(a.href, location.href);
    if (url.pathname !== location.pathname || url.origin !== location.origin) return;
    var id = url.hash;
    if (id.length < 2) return;
    var el = document.querySelector(id);
    if (!el) return;
    e.preventDefault();
    closeMenu();
    if (lenis) lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* reveals */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });
  document.querySelectorAll('.rv, .rv-group, .rv-img, .lines').forEach(function (el) { io.observe(el); });

  /* parallax on .px images */
  var pxs = [].slice.call(document.querySelectorAll('.px'));
  function parallax() {
    var h = window.innerHeight;
    pxs.forEach(function (box) {
      var r = box.getBoundingClientRect();
      if (r.bottom < 0 || r.top > h) return;
      var p = (r.top + r.height / 2 - h / 2) / (h + r.height); /* -0.5 .. 0.5 */
      var img = box.querySelector('img');
      if (img) img.style.setProperty('--py', (p * -14) + '%');
    });
  }
  if (!reduce && pxs.length) {
    window.addEventListener('scroll', parallax, { passive: true });
    window.addEventListener('resize', parallax);
    parallax();
  }

  /* header */
  var header = document.querySelector('.site-header');
  var buybar = document.querySelector('.buybar');
  var hero = document.querySelector('.hero') || document.querySelector('.pdp'); /* sticky buy bar appears once this is mostly scrolled past */
  function onScroll() {
    var y = window.scrollY;
    if (header) header.classList.toggle('solid', y > 24);
    if (buybar && hero) buybar.classList.toggle('show', y > hero.offsetHeight * 0.8 && !body.classList.contains('menu-open'));
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* mobile menu */
  var burger = document.querySelector('.burger');
  var menu = document.querySelector('.menu');
  function closeMenu() {
    body.classList.remove('menu-open');
    if (menu) menu.classList.remove('open');
    if (lenis) lenis.start();
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }
  if (burger && menu) {
    burger.addEventListener('click', function () {
      var open = !menu.classList.contains('open');
      menu.classList.toggle('open', open);
      body.classList.toggle('menu-open', open);
      burger.setAttribute('aria-expanded', open);
      if (lenis) open ? lenis.stop() : lenis.start();
      onScroll();
    });
  }

  /* phone menu: Shop opens its list */
  document.querySelectorAll('.m-drop-t').forEach(function (t) {
    t.addEventListener('click', function () {
      var d = t.parentNode, open = !d.classList.contains('open');
      d.classList.toggle('open', open);
      t.setAttribute('aria-expanded', open);
    });
  });

  /* intro: once per session */
  var intro = document.querySelector('.intro');
  var enterTargets = ['.hero', '.site-header', '.announce'];
  function enterPage() { enterTargets.forEach(function (s) { var el = document.querySelector(s); if (el) el.classList.add('enter'); }); }
  if (!intro) enterPage();
  if (intro) {
    var seen = body.classList.contains('design-mode');
    var everyReload = intro.getAttribute('data-every') === 'true';
    if (!everyReload && !seen) { try { seen = sessionStorage.getItem('twl-intro') === '1'; } catch (e) {} }
    if (seen || reduce) { intro.remove(); enterPage(); }
    else {
      try { sessionStorage.setItem('twl-intro', '1'); } catch (e) {}
      if (lenis) lenis.stop();
      var ending = false;
      /* cross-fade straight into the page while the clip is still moving, so it never sits on a frozen last frame */
      var endIntro = function () {
        if (ending) return;
        ending = true;
        intro.classList.add('leaving', 'done');
        enterPage();
        if (lenis) lenis.start();
        setTimeout(function () { var v = intro.querySelector('video'); if (v) v.pause(); intro.remove(); }, 1300);
      };
      /* start leaving just before the clip ends (fallback timer if the clip never plays) */
      var iv = intro.querySelector('video');
      if (iv) {
        iv.addEventListener('timeupdate', function () { if (iv.duration && iv.currentTime >= iv.duration - 0.9) endIntro(); });
        iv.addEventListener('ended', endIntro);
        iv.addEventListener('error', endIntro);
        iv.play().catch(function () {});
      }
      setTimeout(endIntro, parseInt(intro.getAttribute('data-ms') || '3600', 10));
      intro.querySelector('.skip').addEventListener('click', endIntro);
    }
  }

  /* inline video: [data-inline] plays the file inside the card itself */
  var current = null;
  function stopInline() {
    if (!current) return;
    var v = current.querySelector('video');
    if (v) { v.pause(); v.remove(); }
    current.classList.remove('playing');
    current = null;
  }
  document.addEventListener('click', function (e) {
    var stop = e.target.closest('.inplay .stop');
    if (stop) { e.preventDefault(); e.stopPropagation(); stopInline(); return; }
    var card = e.target.closest('[data-inline]');
    if (!card || card.classList.contains('playing')) return;
    e.preventDefault();
    stopInline();
    var v = document.createElement('video');
    v.src = card.getAttribute('data-inline');
    v.setAttribute('playsinline', '');
    v.controls = true;
    card.appendChild(v);
    card.classList.add('playing');
    current = card;
    v.addEventListener('ended', stopInline);
    v.play().catch(function () {});
  });
  /* "watch our story" buttons jump to the founder card and start it there */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-play-in]');
    if (!t) return;
    e.preventDefault();
    var card = document.querySelector(t.getAttribute('data-play-in'));
    if (!card) return;
    if (lenis) lenis.scrollTo(card, { offset: -90, duration: 1.2 }); else card.scrollIntoView({ behavior: 'smooth' });
    setTimeout(function () { card.click(); }, lenis ? 1250 : 700);
  });

  /* video modal: any [data-video] opens the file in a modal */
  var modal = document.createElement('div');
  modal.className = 'vmodal';
  modal.innerHTML = '<button class="x" aria-label="Close">&times;</button><video controls playsinline preload="none"></video>';
  document.body.appendChild(modal);
  var mv = modal.querySelector('video');
  function closeVideo() { modal.classList.remove('open'); mv.pause(); mv.removeAttribute('src'); mv.load(); if (lenis) lenis.start(); }
  modal.querySelector('.x').addEventListener('click', closeVideo);
  modal.addEventListener('click', function (e) { if (e.target === modal) closeVideo(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeVideo(); closeMenu(); stopInline(); } });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-video]');
    if (!t) return;
    e.preventDefault();
    mv.classList.toggle('portrait', t.getAttribute('data-orient') === 'portrait');
    mv.src = t.getAttribute('data-video');
    if (t.getAttribute('data-poster')) mv.poster = t.getAttribute('data-poster');
    modal.classList.add('open');
    if (lenis) lenis.stop();
    mv.play().catch(function () {});
  });

  /* accordions */
  document.querySelectorAll('.acc').forEach(function (acc) {
    acc.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) acc.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });

  /* horizontal rows with arrows */
  document.querySelectorAll('[data-row]').forEach(function (wrap) {
    var row = wrap.querySelector('.row');
    wrap.querySelectorAll('[data-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        /* jump to the exact next or previous card, so it never fights the scroll snapping */
        var pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
        var cards = [].slice.call(row.children).filter(function (c) { return c.offsetWidth > 2; });
        var stops = cards.map(function (c) { return c.offsetLeft - pad; }); /* row is position: relative, so offsetLeft is measured inside it */
        var x = row.scrollLeft, next = b.getAttribute('data-dir') === 'next';
        var target = next
          ? stops.filter(function (s) { return s > x + 4; })[0]
          : stops.filter(function (s) { return s < x - 4; }).pop();
        if (target === undefined) target = next ? row.scrollWidth : 0;
        row.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
  });

  /* cart: Shopify AJAX API (window.TWL_CART comes from layout/twl.liquid) */
  var CART = window.TWL_CART || { count: 0, url: '/cart', add: '/cart/add.js' };
  function setCount(n) { document.querySelectorAll('.cart .n').forEach(function (el) { el.textContent = n; }); }
  function addToCart(item) {
    return fetch(CART.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); document.dispatchEvent(new CustomEvent('twl:added', { detail: cart })); return cart; });
  }
  /* the line item for an add button: the checked purchase option (with its selling plan) and the quantity */
  function itemFor(b) {
    var item = { id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 };
    var sec = b.closest('.product, .pdp') || document.querySelector('.product, .pdp');
    var sel = sec && sec.querySelector('.plans input:checked');
    var act = b.closest('.act');
    if (act && sel && sel.getAttribute('data-plan')) item.selling_plan = parseInt(sel.getAttribute('data-plan'), 10);
    else if (act) { var q = act.querySelector('output'); item.quantity = parseInt(q && q.value, 10) || 1; }
    else item.quantity = parseInt(b.getAttribute('data-add'), 10) || 1;
    return item;
  }

  function updateBuy() {
    var sel = document.querySelector('.plans input:checked');
    var act = document.querySelector('.buy .act');
    if (!sel || !act) return;
    var sub = sel.value === 'sub';
    act.classList.toggle('sub', sub);
    var q = act.querySelector('output');
    var n = sub ? 1 : (parseInt(q && q.value, 10) || 1);
    var amt = act.querySelector('.amt');
    var next = '$' + (parseFloat(sel.getAttribute('data-price')) * n).toFixed(2);
    if (amt && amt.textContent !== next) { amt.textContent = next; amt.classList.remove('tick'); void amt.offsetWidth; amt.classList.add('tick'); }
  }
  document.addEventListener('change', function (e) { if (e.target.closest('.plans')) updateBuy(); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-qty]')) setTimeout(updateBuy, 0); });

  /* add to cart that freezes: frost spreads over the whole button, it grows slightly, then thaws (hover frost is pure CSS) */
  function freeze(b) {
    if (b.classList.contains('frozen')) return;
    var lbl = b.querySelector('.lbl');
    var old = lbl ? lbl.innerHTML : '';
    b.classList.remove('thaw');
    b.classList.add('frozen');
    var msg = document.querySelector('.added-msg');
    if (lbl) lbl.textContent = (msg && msg.getAttribute('data-added')) || 'Added. Stay cool.';
    setTimeout(function () {
      b.classList.add('thaw');
      b.classList.remove('frozen');
      if (lbl) lbl.innerHTML = old;
      setTimeout(function () { b.classList.remove('thaw'); }, 1100);
    }, 2000);
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var out = q.parentNode.querySelector('output');
      out.value = Math.max(1, (parseInt(out.value, 10) || 1) + parseInt(q.getAttribute('data-qty'), 10));
      return;
    }
    var b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('busy')) return;
    b.classList.add('busy');
    var frosty = b.classList.contains('frosty');
    var old = b.innerHTML;
    /* the frost plays at once on click; the bag slides in as soon as Shopify confirms */
    if (frosty) freeze(b);
    addToCart(itemFor(b)).then(function () {
      b.classList.remove('busy');
      if (frosty) return;
      b.innerHTML = 'Added to cart';
      b.classList.add('done');
      setTimeout(function () { b.innerHTML = old; b.classList.remove('done'); }, 1600);
    }).catch(function (err) {
      b.classList.remove('busy');
      document.dispatchEvent(new Event('twl:addfail'));
      alert(err.message);
    });
  });

  /* product gallery: thumbs jump the stage; swiping updates thumbs, counter and dots */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var stage = g.querySelector('.stage'), slides = [].slice.call(stage.children);
    var thumbs = [].slice.call(g.querySelectorAll('.thumbs button')), count = g.querySelector('.count'), dots = g.querySelector('.dots');
    if (dots) slides.forEach(function () { dots.appendChild(document.createElement('i')); });
    function mark(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      g.classList.toggle('past-first', i > 0); /* the badge belongs to the first photo only */
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); mark(i); }); });
    slides.forEach(function (s, i) { s.addEventListener('click', function () { openLightbox(slides.map(function (x) { return x.querySelector('img'); }), i); }); });
    var tick;
    stage.addEventListener('scroll', function () { clearTimeout(tick); tick = setTimeout(function () { mark(Math.round(stage.scrollLeft / stage.clientWidth)); }, 60); }, { passive: true });
    mark(0);
  });

  /* lightbox: full screen photo, click to zoom (follows the pointer), arrows, swipe, Esc */
  var lb = null;
  function openLightbox(imgs, start) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.innerHTML = '<button class="lb-x" aria-label="Close">&times;</button><button class="lb-prev" aria-label="Previous photo"><svg viewBox="0 0 16 16"><path d="M10 2 4 8l6 6"/></svg></button><figure><img alt=""></figure><button class="lb-next" aria-label="Next photo"><svg viewBox="0 0 16 16"><path d="m6 2 6 6-6 6"/></svg></button><span class="lb-count"></span><span class="lb-hint">Click to zoom</span>';
      document.body.appendChild(lb);
    }
    var fig = lb.querySelector('figure'), im = lb.querySelector('img'), i = start, sx = null;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      fig.classList.remove('zoomed'); hint();
      im.src = imgs[i].currentSrc || imgs[i].src; im.alt = imgs[i].alt;
      lb.querySelector('.lb-count').textContent = (i + 1) + ' / ' + imgs.length;
    }
    function aim(e) { var r = im.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; }
    function close() { lb.classList.remove('open'); body.classList.remove('lb-open'); if (lenis) lenis.start(); document.removeEventListener('keydown', key); }
    function key(e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(i + 1); if (e.key === 'ArrowLeft') show(i - 1); }
    lb.querySelector('.lb-x').onclick = close;
    lb.querySelector('.lb-prev').onclick = function () { show(i - 1); };
    lb.querySelector('.lb-next').onclick = function () { show(i + 1); };
    lb.onclick = function (e) { if (e.target === lb) close(); };
    function hint() { lb.querySelector('.lb-hint').textContent = fig.classList.contains('zoomed') ? 'Click to zoom out' : 'Click to zoom'; }
    im.onclick = function (e) { aim(e); fig.classList.toggle('zoomed'); hint(); };
    im.onpointermove = function (e) { if (fig.classList.contains('zoomed')) aim(e); };
    /* swipe between photos when not zoomed */
    fig.onpointerdown = function (e) { sx = fig.classList.contains('zoomed') ? null : e.clientX; };
    fig.onpointerup = function (e) { if (sx !== null && Math.abs(e.clientX - sx) > 50) show(i + (e.clientX < sx ? 1 : -1)); sx = null; };
    document.addEventListener('keydown', key);
    show(start);
    lb.classList.add('open'); body.classList.add('lb-open');
    if (lenis) lenis.stop();
  }

  /* FAQ page: search filters the questions; the topic list follows the scroll */
  var fq = document.querySelector('[data-faq-search]');
  if (fq) {
    var fbody = document.querySelector('.faq-body'), groups = [].slice.call(document.querySelectorAll('.faq-group'));
    fq.addEventListener('input', function () {
      var q = fq.value.trim().toLowerCase(), any = false;
      fbody.classList.toggle('searching', !!q);
      groups.forEach(function (g) {
        var hit = 0;
        g.querySelectorAll('details').forEach(function (d) {
          var ok = !q || d.textContent.toLowerCase().indexOf(q) > -1;
          d.style.display = ok ? '' : 'none';
          if (ok) hit++;
          if (q && ok) d.open = true;
        });
        g.style.display = hit ? '' : 'none';
        if (hit) any = true;
      });
      document.querySelector('.faq-empty').style.display = any ? 'none' : 'block';
    });
    var cats = [].slice.call(document.querySelectorAll('.faq-cats a'));
    var spy = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cats.forEach(function (a) { var on = a.getAttribute('href') === '#' + e.target.id; a.classList.toggle('on', on); if (on && a.scrollIntoView && window.innerWidth < 860) a.parentNode.scrollTo({ left: a.offsetLeft - 20, behavior: 'smooth' }); });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    groups.forEach(function (g) { spy.observe(g); });
  }

  /* landing pages: countdown to [data-countdown] (ISO date) and a sticky offer bar after the hero */
  document.querySelectorAll('[data-countdown]').forEach(function (cd) {
    var to = new Date(cd.getAttribute('data-countdown')).getTime(), cells = cd.querySelectorAll('b');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((to - Date.now()) / 1000));
      [Math.floor(s / 86400), Math.floor(s / 3600) % 24, Math.floor(s / 60) % 60, s % 60].forEach(function (v, k) { if (cells[k]) cells[k].textContent = pad(v); });
    }
    tick(); setInterval(tick, 1000);
  });
  var lpBar = document.querySelector('.lp-bar'), lpHero = document.querySelector('.lp-hero');
  if (lpBar && lpHero) {
    window.addEventListener('scroll', function () { lpBar.classList.toggle('show', window.scrollY > lpHero.offsetHeight * 0.85); }, { passive: true });
  }

  /* reviews: stars only for reviews that carry a real rating (data-rating 1 to 5); the summary and the product
     rating line appear once at least one review is rated. Six cards show at first, the rest behind "Show more" */
  var STAR = '<svg viewBox="0 0 20 20"><path d="m10 1.8 2.5 5.3 5.8.7-4.3 4 1.1 5.7L10 14.7l-5.1 2.8 1.1-5.7-4.3-4 5.8-.7z"/></svg>';
  function starRow(r) { var h = ''; for (var k = 1; k <= 5; k++) h += '<i class="' + (r >= k - .25 ? 'on' : r >= k - .75 ? 'half' : '') + '">' + STAR + '</i>'; return h; }
  document.querySelectorAll('.reviews').forEach(function (sec) {
    var cards = [].slice.call(sec.querySelectorAll('.rv-card')), sum = 0, n = 0;
    cards.forEach(function (c) {
      var r = parseFloat(c.getAttribute('data-rating'));
      if (r >= 1 && r <= 5) { sum += r; n++; c.querySelector('.stars').innerHTML = starRow(r); c.querySelector('.stars').setAttribute('aria-label', r + ' out of 5'); }
    });
    var avg = n ? Math.round(sum / n * 10) / 10 : 0;
    var box = sec.querySelector('.avg');
    if (box && n) box.innerHTML = '<b>' + avg.toFixed(1) + '</b><span class="stars">' + starRow(avg) + '</span><small>' + n + (n === 1 ? ' review' : ' reviews') + '</small>';
    document.querySelectorAll('.pdp .rating').forEach(function (a) {
      if (!n) return;
      a.querySelector('.stars').innerHTML = starRow(avg);
      a.querySelector('.rtxt').textContent = avg.toFixed(1) + ' (' + n + (n === 1 ? ' review' : ' reviews') + ')';
      a.classList.add('rated');
    });
    var more = sec.querySelector('.rv-more');
    if (cards.length > 6 && more) {
      sec.classList.add('folded');
      more.addEventListener('click', function () { sec.classList.remove('folded'); more.parentNode.remove(); });
    } else if (more) more.parentNode.remove();
  });

  /* journal: topic filter; article: highlight the section being read */
  document.querySelectorAll('.j-filter button').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.getAttribute('data-f');
      document.querySelectorAll('.j-filter button').forEach(function (x) { x.classList.toggle('on', x === b); });
      document.querySelectorAll('.j-list .j-grid .jcard').forEach(function (c) { c.classList.toggle('hide', f !== 'all' && c.getAttribute('data-topic') !== f); });
    });
  });
  var tocLinks = [].slice.call(document.querySelectorAll('.toc a'));
  if (tocLinks.length) {
    var tocSpy = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) tocLinks.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id); }); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    document.querySelectorAll('.prose h2[id]').forEach(function (h) { tocSpy.observe(h); });
  }

  /* living photos: .vloop videos play only while on screen, never for reduced motion */
  var loops = document.querySelectorAll('.vloop');
  if (loops.length && !reduce) {
    var lio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: .15 });
    loops.forEach(function (v) { lio.observe(v); });
  }

  /* letters signup: a warm dusk breeze sweeps across and erases the card, the letter is revealed under it in sunset light,
     then the glow settles to the edges and the thank you appears on the paper in perspective */
  var DUSK = '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M8 20a8 8 0 0 1 16 0M3 20h26M16 6v3M6.8 9.8l2.1 2.1M25.2 9.8l-2.1 2.1M7 25h12M21 25h4"/></svg>';
  /* the paper's corners in letters-warm.webp (same layout as the old letters-cold.webp) (1800 x 1013): top left, top right, bottom right, bottom left */
  var PAPER = [[-80, 515], [810, 400], [1265, 780], [175, 945]], STAGE = [1800, 1013];
  function lerp(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }
  function onPaper(u, v) { return lerp(lerp(PAPER[0], PAPER[1], u), lerp(PAPER[3], PAPER[2], u), v); }
  /* CSS matrix3d that maps the rectangle w x h onto the quad q (homography, solved directly) */
  function quadMatrix(w, h, q) {
    var A = [], B = [], src = [[0, 0], [w, 0], [w, h], [0, h]];
    for (var i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], X = q[i][0], Y = q[i][1];
      A.push([x, y, 1, 0, 0, 0, -x * X, -y * X]); B.push(X);
      A.push([0, 0, 0, x, y, 1, -x * Y, -y * Y]); B.push(Y);
    }
    for (var c = 0; c < 8; c++) { /* gaussian elimination */
      var p = c; for (var r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[p][c])) p = r;
      var t = A[c]; A[c] = A[p]; A[p] = t; t = B[c]; B[c] = B[p]; B[p] = t;
      for (r = 0; r < 8; r++) if (r !== c) { var f = A[r][c] / A[c][c]; for (var k = c; k < 8; k++) A[r][k] -= f * A[c][k]; B[r] -= f * B[c]; }
    }
    var m = B.map(function (b, i) { return b / A[i][i]; });
    return 'matrix3d(' + [m[0], m[3], 0, m[6], m[1], m[4], 0, m[7], 0, 0, 1, 0, m[2], m[5], 0, 1].join(',') + ')';
  }
  function placeLetter(card) {
    var stage = card.querySelector('.cold-stage'), note = card.querySelector('.cold .note');
    if (!stage || !note) return;
    var cw = card.clientWidth, narrow = cw < 700, ch = narrow && card.dataset.coldH ? +card.dataset.coldH : card.clientHeight;
    /* wide cards: the scene covers the card. Phones: the paper fills the width as a band across the middle */
    var sc, ox, oy;
    if (narrow) { sc = cw / 720; ox = -190 * sc; oy = ch / 2 - 680 * sc; }
    else { sc = Math.max(cw / STAGE[0], ch / STAGE[1]); ox = (cw - STAGE[0] * sc) * 0.5; oy = (ch - STAGE[1] * sc) * 0.62; }
    card.classList.toggle('cold-narrow', narrow);
    stage.style.transform = 'translate(' + ox + 'px,' + oy + 'px) scale(' + sc + ')';
    /* writing area: the part of the paper that is on screen, with a margin */
    var xa = -ox / sc + 40, xb = (cw - ox) / sc - 40;
    var ua = Math.max(0.15, (xa - 47) / 990), ub = Math.min(0.86, (xb - 47) / 990);
    var va = 0.2, vb = 0.84, w = Math.round(1000 * (ub - ua)), h = 520;
    note.style.width = w + 'px'; note.style.height = h + 'px';
    note.style.transform = quadMatrix(w, h, [onPaper(ua, va), onPaper(ub, va), onPaper(ub, vb), onPaper(ua, vb)]);
  }
  window.TWLchill = function (card) {
    if (!card.querySelector('.cold')) {
      var cold = document.createElement('div');
      cold.className = 'cold'; cold.setAttribute('aria-hidden', 'true');
      cold.innerHTML = '<div class="cold-stage"><img src="' + ((window.TWL_CART || {}).cold || '') + '" alt=""><div class="note"><small>A letter for you</small><b>Welcome to the community.</b><p>Your first letter is on its way. Stay cool.</p><span class="sig">Wise love, Tricia</span></div></div>';
      card.appendChild(cold);
    }
    if (!card.querySelector('.chill')) {
      var c = document.createElement('div');
      c.className = 'chill'; c.setAttribute('aria-hidden', 'true');
      c.innerHTML = '<i class="frost"></i><i class="frost edge"></i><i class="tint"></i><i class="m m1"></i><i class="m m2"></i><i class="m m3"></i><i class="m m4"></i>';
      card.appendChild(c);
    }
    placeLetter(card);
    window.addEventListener('resize', function () { placeLetter(card); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add('chilled'); }); });
    /* phones: once the old card is erased, shrink it smoothly to fit the letter band */
    if (card.clientWidth < 700) {
      card.style.height = card.offsetHeight + 'px';
      setTimeout(function () { var h = Math.round(card.clientWidth / 720 * 560); card.dataset.coldH = h; card.style.height = h + 'px'; placeLetter(card);
        var top = card.getBoundingClientRect().top + window.scrollY - 90;
        if (lenis) lenis.scrollTo(top, { duration: 1 }); else window.scrollTo({ top: top, behavior: 'smooth' }); }, 1950);
    }
    setTimeout(function () { card.classList.add('settled'); }, 1900);
    setTimeout(function () { card.classList.add('reveal'); }, 2300);
  };
  document.querySelectorAll('form[data-chill]').forEach(function (f) {
    if (f.querySelector('input[type=email]') || !/customer_posted=true/.test(location.search)) return;
    setTimeout(function () { f.dispatchEvent(new Event('twl:chill', { cancelable: true })); }, 900);
    f.addEventListener('twl:chill', function (e) {
      e.preventDefault();
      var card = f.closest('.card');
      /* keep the form where it is (no jump); the frost erases it */
      f.querySelectorAll('input, button').forEach(function (el) { el.disabled = true; });
      var t = document.createElement('div');
      t.className = 'thanks' + (reduce ? '' : ' sr'); t.setAttribute('role', 'status');
      t.innerHTML = '<span class="tk-flake">' + DUSK + '</span><b>Welcome to the community.</b><p>Your first letter is on its way. Stay cool.</p>';
      if (reduce) f.replaceWith(t); else card.appendChild(t);
      if (card && !reduce) window.TWLchill(card);
    });
  });

  /* the bag: a slide-out cart drawer on the Shopify cart (/cart.js). Empty = a leopard asleep on the line */
  var bagCart = null;
  /* amounts in the shopper's own currency (Shopify Markets converts outside the US, for example AED in the UAE) */
  function money(cents) {
    var cur = (bagCart && bagCart.currency) || ((window.Shopify || {}).currency || {}).active || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  var drawer = document.createElement('div');
  drawer.className = 'bag';
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML = '<div class="bag-shade" data-bag-close></div>' +
    '<aside class="bag-panel" role="dialog" aria-label="Your bag">' +
      '<header class="bag-head"><div><span class="eyebrow">Your bag</span><b class="bag-title">Savannah ritual</b></div><button class="bag-x" data-bag-close aria-label="Close">&times;</button></header>' +
      '<div class="bag-body"></div>' +
      '<footer class="bag-foot"></footer>' +
    '</aside>';
  document.body.appendChild(drawer);
  var bagBody = drawer.querySelector('.bag-body'), bagFoot = drawer.querySelector('.bag-foot');

  /* regular (compare at) prices per product, so the bag can show the 40% off */
  var compareAt = {}, plansFor = {}, oneBottle = {};
  function loadCompare(c) {
    var need = c.items.map(function (it) { return it.handle; }).filter(function (h, i, a) { return h && compareAt[h] === undefined && a.indexOf(h) === i; });
    return Promise.all(need.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (p) {
          compareAt[h] = p.compare_at_price || 0;
          oneBottle[h] = p.price || 0;
          /* the subscriptions this shopper can buy (none outside the US): group name plus the plan price in her currency */
          var alloc = {};
          ((p.variants[0] || {}).selling_plan_allocations || []).forEach(function (a) { alloc[a.selling_plan_id] = a.price; });
          plansFor[h] = [];
          (p.selling_plan_groups || []).forEach(function (g) {
            (g.selling_plans || []).forEach(function (sp) {
              if (alloc[sp.id] === undefined) return;
              var m = g.name.match(/^(.*?)\s*\((save [^)]*)\)/i);
              plansFor[h].push({ id: sp.id, title: m ? m[1] : g.name, save: m ? m[2] : '', price: alloc[sp.id] });
            });
          });
        }).catch(function () { compareAt[h] = 0; plansFor[h] = []; });
    }));
  }
  function loadBag() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { bagCart = c; renderBag(); return c; });
  }
  /* Black Friday buy 2 get 1 free (automatic discount in Shopify) runs between these moments */
  var BF_START = new Date("2026-11-24T00:00:00-05:00").getTime();
  var BF_END = new Date('2026-11-30T23:59:00-05:00').getTime();
  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5c.6 4.6 2.4 6.9 7 9.5-4.6 2.6-6.4 4.9-7 9.5-.6-4.6-2.4-6.9-7-9.5 4.6-2.6 6.4-4.9 7-9.5Z"/></svg>';
  function renderBag() {
    var c = bagCart || { items: [], item_count: 0, total_price: 0, original_total_price: 0 };
    document.querySelectorAll('.cart .n').forEach(function (el) { el.textContent = c.item_count; });
    drawer.classList.toggle('is-empty', !c.items.length);
    drawer.querySelector('.bag-title').textContent = c.items.length ? c.item_count + (c.item_count === 1 ? ' item' : ' items') : 'Resting for now';
    if (!c.items.length) {
      bagBody.innerHTML = '<div class="bag-empty"><b>Your bag is resting.</b><p>The leopard is napping until you find something you love.</p><a href="' + CART.shop + '" class="btn foil">Shop the mist</a></div>' +
        '<div class="nap" aria-hidden="true"><span class="nap-line"></span><img src="' + CART.sleep + '" alt=""><i class="z z1">z</i><i class="z z2">z</i><i class="z z3">z</i></div>';
      bagFoot.innerHTML = '';
      return;
    }
    if (c.items.some(function (it) { return it.handle && compareAt[it.handle] === undefined; })) { loadCompare(c).then(renderBag); }
    var hasSub = false, saved = 0, freeBottles = 0, oneQty = 0, oneLine = 0, pct = 0;
    var lines = c.items.map(function (it, k) {
      var cmp = compareAt[it.handle] || 0, unit = it.original_price, tags = '', was = 0;
      if (it.selling_plan_allocation) {
        /* a plan line is one delivery of N bottles; its regular price is N bottles at the one bottle price */
        var spid = it.selling_plan_allocation.selling_plan.id;
        var plan = (plansFor[it.handle] || []).filter(function (o) { return o.id === spid; })[0];
        var label = plan ? plan.title + ' ' + plan.save : it.selling_plan_allocation.selling_plan.name;
        var n = parseInt((label.match(/(\d+) bottles/) || [])[1], 10) || 1, off = (label.match(/save (\d+)%/i) || [])[1];
        it._plan = plan ? plan.title : '';
        was = n * (oneBottle[it.handle] || unit) * it.quantity;
        if (off) tags += '<span class="bi-pill">Save ' + off + '%</span>';
      } else {
        oneQty += it.quantity; oneLine = k + 1;
        if (cmp > unit) { was = cmp * it.quantity; pct = Math.round((1 - unit / cmp) * 100); tags += '<span class="bi-pill">' + pct + '% off</span>'; }
        (it.line_level_discount_allocations || []).forEach(function (d) {
          if (!d.amount) return;
          if (d.discount_application && d.discount_application.type === 'discount_code') {
            tags += '<span class="bi-deal">' + SPARK + esc(d.discount_application.title) + '</span>';
            return;
          }
          var free = Math.round(d.amount / unit);
          freeBottles += free;
          tags += '<span class="bi-deal">' + SPARK + (free ? free + (free === 1 ? ' bottle' : ' bottles') + ' free' : esc(d.discount_application.title)) + '</span>';
        });
      }
      if (was > it.final_line_price) saved += was - it.final_line_price;
      it._was = was; it._tags = tags;
      return it;
    });
    /* order level discounts (a code for the whole bag) are not in the line prices */
    (c.cart_level_discount_applications || []).forEach(function (d) { saved += d.total_allocated_amount || 0; });
    var win = saved > 0 ? '<div class="bag-win"><span class="bw-spark">' + SPARK + '</span><div><b>You are saving ' + money(saved) + '</b><small>' +
      (pct ? pct + '% off the regular price' : 'Subscriber pricing') + (freeBottles ? ', plus ' + freeBottles + (freeBottles === 1 ? ' bottle' : ' bottles') + ' on us' : '') + '</small></div></div>' : '';
    var bf = Date.now() >= BF_START && Date.now() < BF_END && oneQty ? oneQty % 3 : 0;
    var nudge = bf ? '<button class="bag-nudge" data-bq="' + oneLine + '" data-q="' + (lines[oneLine - 1].quantity + 3 - bf) + '"><span class="chip on-light"><i>' + SPARK + '</i>Black Friday</span>' +
      '<span>' + (bf === 2 ? 'Add one more bottle and it is <b>free</b>.' : 'Add two more and the third bottle is <b>free</b>.') + '</span><span class="bn-go">' + (bf === 2 ? 'Add the free bottle' : 'Add 2 more') + '</span></button>' : '';
    bagBody.innerHTML = win + lines.map(function (it, k) {
      var plan = it.selling_plan_allocation ? (it._plan || it.selling_plan_allocation.selling_plan.name) : (it.variant_title || 'One bottle');
      if (it.selling_plan_allocation) hasSub = true;
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      return '<div class="bag-item">' + (img ? '<img src="' + img + '" alt="">' : '') + '<div class="bi-t"><b>' + esc(it.product_title) + '</b><small>' + esc(plan) + '</small>' +
        (it._tags ? '<div class="bi-tags">' + it._tags + '</div>' : '') +
        (it.selling_plan_allocation ? '<span class="bi-sub">Pause or cancel anytime</span>' : '') +
        '<div class="bi-qty"><button data-bq="' + (k + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Less">&minus;</button><span>' + it.quantity + '</span><button data-bq="' + (k + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="More">+</button></div>' +
        '</div><div class="bi-p"><b>' + money(it.final_line_price) + '</b>' + (it._was > it.final_line_price ? '<s>' + money(it._was) + '</s>' : '') + '<button class="bi-x" data-bq="' + (k + 1) + '" data-q="0">Remove</button></div></div>';
    }).join('') + nudge + (hasSub || nudge ? '' : ritual(lines, oneLine));
    bagFoot.innerHTML = codeBox(c) + (saved > 0 ? '<div class="bag-row save"><span>You save</span><span>' + money(saved) + '</span></div>' : '') +
      '<div class="bag-row total"><span>Subtotal</span><b>' + money(c.total_price) + '</b></div>' +
      '<p class="bag-note">Shipping calculated at checkout. Ships from New York City.</p>' +
      '<a href="/checkout" class="btn foil bag-go">Checkout</a>' +
      '<div class="bag-pay">' + payIcons() + '</div>';
  }
  /* make it a ritual: one tap swaps the one-time bottle in the bag for a subscription (US only, where Shopify has plans) */
  function ritual(lines, oneLine) {
    var it = oneLine && lines[oneLine - 1], pl = it ? plansFor[it.handle] : null;
    if (!pl || !pl.length) return '';
    return '<div class="bag-upsell"><span class="chip on-light"><i><svg viewBox="0 0 24 24"><path d="M12 3.5c3.5 4.2 5.5 7 5.5 10a5.5 5.5 0 0 1-11 0c0-3 2-5.8 5.5-10Z"/></svg></i>Make it a ritual</span>' +
      '<span>Switch to a subscription and save. Delivered to your door, pause or cancel anytime.</span><div class="bu-opts">' +
      pl.map(function (o) {
        return '<button type="button" class="bu-opt" data-sub-line="' + oneLine + '" data-sub-plan="' + o.id + '"><span class="bu-t"><b>' + esc(o.title) + '</b>' + (o.save ? '<small>' + esc(o.save.charAt(0).toUpperCase() + o.save.slice(1)) + '</small>' : '') + '</span><span class="bu-p">' + money(o.price) + '</span></button>';
      }).join('') + '</div></div>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sub-plan]');
    if (!b) return;
    b.classList.add('busy');
    fetch(CART.change || '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.getAttribute('data-sub-line'), quantity: 1, selling_plan: +b.getAttribute('data-sub-plan') }) })
      .then(function (r) { return r.json(); }).then(function (c) { if (c.items) { bagCart = c; renderBag(); } else b.classList.remove('busy'); })
      .catch(function () { b.classList.remove('busy'); });
  });

  /* the store's real payment methods, as Shopify's own logos (template in layout/twl.liquid) */
  function payIcons() {
    var t = document.getElementById('twl-pay');
    return t && t.innerHTML.trim() ? t.innerHTML : '<span>Shop Pay</span><span>Apple Pay</span><span>Visa</span><span>Mastercard</span>';
  }

  /* discount codes live on the Shopify cart, so a code added here is already filled in at checkout */
  var codeMsg = '';
  function codeAmount(c, code) {
    var amt = 0, k = code.toLowerCase();
    (c.cart_level_discount_applications || []).forEach(function (d) { if ((d.title || '').toLowerCase() === k) amt += d.total_allocated_amount || 0; });
    c.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (d) { if (d.discount_application && (d.discount_application.title || '').toLowerCase() === k) amt += d.amount || 0; });
    });
    return amt;
  }
  function codeBox(c) {
    var codes = c.discount_codes || [];
    var chips = codes.map(function (d) {
      var amt = d.applicable ? codeAmount(c, d.code) : 0;
      return '<span class="bc-chip' + (d.applicable ? '' : ' bad') + '">' + SPARK + '<span>' + esc(d.code) + (amt ? ' <b>' + money(amt) + ' off</b>' : '') + '</span>' +
        '<button type="button" data-code-x="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">&times;</button></span>';
    }).join('');
    return '<div class="bag-code">' + (chips ? '<div class="bc-chips">' + chips + '</div>' : '') +
      '<form class="bc-form" novalidate><input name="code" type="text" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="Discount code"><button type="submit">Apply</button></form>' +
      (codeMsg ? '<p class="bc-msg">' + esc(codeMsg) + '</p>' : '') + '</div>';
  }
  function setCodes(list, added) {
    var form = bagFoot.querySelector('.bc-form');
    if (form) form.classList.add('busy');
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        codeMsg = '';
        if (added) {
          var hit = (c.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === added.toLowerCase(); })[0];
          if (!hit || !hit.applicable) {
            /* a code that does not work is taken off again, only the message stays */
            var msg = 'The code ' + added.toUpperCase() + ' is not valid for this bag.';
            return setCodes((c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; })).then(function () { codeMsg = msg; renderBag(); });
          }
        }
        bagCart = c; renderBag();
      })
      .catch(function () { codeMsg = 'Something went wrong. Please try again.'; renderBag(); });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.bc-form');
    if (!f) return;
    e.preventDefault();
    var code = f.code.value.trim();
    if (!code) return;
    var list = ((bagCart && bagCart.discount_codes) || []).map(function (d) { return d.code; }).filter(function (x) { return x.toLowerCase() !== code.toLowerCase(); });
    setCodes(list.concat(code), code);
  });
  document.addEventListener('click', function (e) {
    var x = e.target.closest('[data-code-x]');
    if (!x) return;
    var code = x.getAttribute('data-code-x').toLowerCase();
    setCodes(((bagCart && bagCart.discount_codes) || []).map(function (d) { return d.code; }).filter(function (c) { return c.toLowerCase() !== code; }));
  });
  function openBag() { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('bag-open'); if (lenis) lenis.stop(); loadBag(); }
  function closeBag() { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); body.classList.remove('bag-open'); if (lenis) lenis.start(); }
  window.TWLbag = { open: openBag, close: closeBag };

  /* an add opens the bag at once with an "adding" line; Shopify's answer (about a second) then fills it in */
  var lastAdd = null;
  function showAdding() {
    var row = '<div class="bag-adding" role="status"><div class="ba-vis" aria-hidden="true"><svg class="ba-bottle" viewBox="0 0 34 56"><rect class="cap" x="12" y="0" width="10" height="7" rx="1.5"/><rect class="cap" x="10" y="7" width="14" height="6" rx="2"/><rect x="4" y="13" width="26" height="43" rx="7"/><rect class="lab" x="9" y="27" width="16" height="14" rx="2"/></svg><i></i><i></i><i></i><i></i></div><div class="ba-t"><b>Misting it into your bag</b><small>One moment, keeping it cool.</small><span class="ba-bar"><span></span></span></div></div>' + (!bagCart || !bagCart.items.length ? '<div class="ba-ghost" aria-hidden="true"><span class="im"></span><span class="ln"><span></span><span></span><span></span></span></div>' : '');
    if (!bagCart || !bagCart.items.length) { drawer.classList.remove('is-empty'); bagBody.innerHTML = row; bagFoot.innerHTML = ''; }
    else bagBody.insertAdjacentHTML('afterbegin', row);
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('bag-open'); if (lenis) lenis.stop();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.classList.contains('busy')) return;
    lastAdd = b;
    setTimeout(showAdding, b.classList.contains('frosty') ? 160 : 60);
  }, true);
  document.addEventListener('twl:added', function (e) {
    bagCart = e.detail;
    setTimeout(renderBag, 180);
  });
  document.addEventListener('twl:addfail', function () { renderBag(); closeBag(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('.cart')) { e.preventDefault(); openBag(); return; }
    if (e.target.closest('[data-bag-close]')) { closeBag(); return; }
    var q = e.target.closest('[data-bq]');
    if (q) {
      fetch(CART.change || '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.getAttribute('data-bq'), quantity: Math.max(0, +q.getAttribute('data-q')) }) })
        .then(function (r) { return r.json(); }).then(function (c) { bagCart = c; renderBag(); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) closeBag(); });
  document.querySelectorAll('.cart .n').forEach(function (el) { el.textContent = CART.count || 0; });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.rv, .rv-group, .rv-img, .lines').forEach(function (el) { el.classList.add('in'); });
    e.target.querySelectorAll('.hero, .site-header, .announce').forEach(function (el) { el.classList.add('enter'); });
    var intro = e.target.querySelector('.intro');
    if (intro) intro.remove();
  });
})();
